;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { useState, useEffect, useRef } from "react"
import get from "lodash/get"
import useStripeCustomer from "../../../../../hooks/stripe/useStripeCustomer"
import updateErrorMessage from "../../../../../graphql/mutations/snackbarMessage/updateErrorMessage"
import AddPaymentMethodDialog from "../AddPaymentMethodDialog"
import Loader from "../../../../common/Loader"
import PaymentElementsCustomer from "../../../../common/PaymentElementsCustomer"

type Props = {
  onClose: () => Promise<void> | void
}

export default function StripeSetupHandler({ onClose }: Props) {
  const [stripeCustomerSecretKey, setStripeCustomerSecretKey] = useState<
    string | null
  >(null)
  const [isDialogOpen, setIsDialogOpen] = useState(true)
  const { registerStripeCustomerAndSetupIntent } = useStripeCustomer()
  const setupAttemptedRef = useRef(false)

  useEffect(() => {
    if (setupAttemptedRef.current) {
      return
    }

    const setUpStripeCustomer = async () => {
      try {
        setupAttemptedRef.current = true
        const secretKey = await registerStripeCustomerAndSetupIntent()
        setStripeCustomerSecretKey(secretKey)
      } catch (error) {
        const errorMessage = get(
          error,
          "message",
          "Failed to prepare adding payment method. Contact support.",
        )
        updateErrorMessage({
          message: errorMessage,
          trackToSentry: true,
          error,
        })
      }
    }

    void setUpStripeCustomer()
  }, [registerStripeCustomerAndSetupIntent])

  const handleCloseDialog = async () => {
    setIsDialogOpen(false)
    await onClose()
  }

  if (!isDialogOpen) {
    return null
  }

  if (!stripeCustomerSecretKey) {
    return <Loader />
  }

  return (
    <PaymentElementsCustomer clientSecret={stripeCustomerSecretKey}>
      <AddPaymentMethodDialog onClose={handleCloseDialog} />
    </PaymentElementsCustomer>
  )
}
